import { IdDescription } from 'tms-lib';

// The record types a funnel file is written with (Pongees points, Oct 2026) - the codes
// FunnelFileService in the API writes at the start of each record, and the Funnel Files search
// matches on. A fixed set, so the API and this list must stay in step.
export enum FunnelFileRecordTypes {
  supplier = 'R08',
  customer = 'R11',
  traderAddress = 'R14',
  product = 'R18',
  purchaseInvoice = 'R50',
  purchaseInvoiceLine = 'R51',
  removal = 'R60',
  removalLine = 'R61',
  freeCirculation = 'R97',
}

// A record type as a person reads it. A function, not a constant array, so $localize runs after
// the language resolver has loaded the translations.
export function funnelFileRecordTypeName(recordType: string | undefined | null): string {
  switch (recordType) {
    case FunnelFileRecordTypes.supplier:
      return $localize`R08 Supplier`;
    case FunnelFileRecordTypes.customer:
      return $localize`R11 Customer`;
    case FunnelFileRecordTypes.traderAddress:
      return $localize`R14 Trader Address`;
    case FunnelFileRecordTypes.product:
      return $localize`R18 Product`;
    case FunnelFileRecordTypes.purchaseInvoice:
      return $localize`R50 Purchase Invoice`;
    case FunnelFileRecordTypes.purchaseInvoiceLine:
      return $localize`R51 Purchase Invoice Line`;
    case FunnelFileRecordTypes.removal:
      return $localize`R60 Removal`;
    case FunnelFileRecordTypes.removalLine:
      return $localize`R61 Removal Line`;
    case FunnelFileRecordTypes.freeCirculation:
      return $localize`R97 Free Circulation`;
    default:
      // Anything unrecognised shows as stored rather than vanishing.
      return recordType ?? '';
  }
}

// The File Type filter's options, in record-type order.
export function funnelFileRecordTypeOptions(): IdDescription[] {
  return Object.values(FunnelFileRecordTypes).map((id) => ({ id, description: funnelFileRecordTypeName(id) }));
}
